$(document).ready(function () {
  // Init Functions
  popUp();
});

function popUp() {

  // Select City
  $('.js-city-popup').on('click', function () {

    $('.js-popup').fadeIn(200);
    $('body').addClass('overflow-h');
    $('.m-select').fadeIn(200);

  });


  // Select Video
  $('.js-video-popup').on('click', function () {
    var videoId = $(this).attr('class').substring(62);
    // console.log(videoId);

    $('body').addClass('overflow-h');
    $('.m-video').fadeIn(200);
    $('.m-video__container--' + videoId).fadeIn(1200);
    $('.m-video__container').each(function () {
      var iframe = $('.m-video__container--' + videoId).find('iframe');
      iframe.attr('src', iframe.data('src'));
    });

  });

  // Close PopUp
  $('.js-close-popup').on('click', function () {

    $('.l-popup').fadeOut(200);
    $('body').removeClass('overflow-h');
    $('.m-select').fadeOut(0);
    $('.l-popup .m-video').fadeOut(0);
    $('.l-popup .m-video__container').fadeOut(0);

    // Stop iframe Videos
    $('.m-video__container').each(function () {
      $('.js-video iframe').removeAttr('src');
    });

  });

}